/**
 * @flow
 * @relayHash 4fa97b0761321f5828805e5244511cef
 */

/* eslint-disable */

"use strict";

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AbsenceAbsenceType = "D" | "O" | "S" | "V" | "%future added value";
export type AbsenceStatus = "A" | "C" | "O" | "P" | "R" | "%future added value";
export type EmployeeActivityActivity = "EB" | "EW" | "SB" | "SW" | "%future added value";
export type NotificationAbsenceStatus = "A" | "C" | "P" | "R" | "%future added value";
export type NotificationSubscriptionVariables = {||};
export type NotificationSubscriptionResponse = {|
  +notificationSubscription: ?{|
    +notification: ?{|
      +id: string,
      +pk: ?number,
      +user: {|
        +pk: ?number,
        +id: string,
        +firstName: string,
        +lastName: string,
      |},
      +seen: boolean,
      +hidden: boolean,
      +management: boolean,
      +absenceStatus: ?NotificationAbsenceStatus,
      +createdAt: any,
      +absence: ?{|
        +status: AbsenceStatus,
        +absenceType: AbsenceAbsenceType,
        +absenceTypeDisplay: ?string,
        +dateFrom: any,
        +dateTo: any,
      |},
      +regardingUser: {|
        +firstName: string,
        +lastName: string,
      |},
      +employeeActivity: ?{|
        +activity: EmployeeActivityActivity
      |},
      +lateness: ?{|
        +declaredTime: any,
        +pk: ?number,
        +createdAt: any,
      |},
      +meeting: ?{|
        +pk: ?number
      |},
      +report: ?{|
        +reportType: {|
          +labelDisplay: ?string
        |},
        +project: {|
          +name: string
        |},
        +pk: ?number,
        +taskIdManager: ?string,
        +numberOfMinutesManager: number,
        +noteManager: string,
      |},
    |}
  |}
|};
export type NotificationSubscription = {|
  variables: NotificationSubscriptionVariables,
  response: NotificationSubscriptionResponse,
|};
*/

/*
subscription NotificationSubscription {
  notificationSubscription {
    notification {
      id
      pk
      user {
        pk
        id
        firstName
        lastName
      }
      seen
      hidden
      management
      absenceStatus
      createdAt
      absence {
        status
        absenceType
        absenceTypeDisplay
        dateFrom
        dateTo
        id
      }
      regardingUser {
        firstName
        lastName
        id
      }
      employeeActivity {
        activity
        id
      }
      lateness {
        declaredTime
        pk
        createdAt
        id
      }
      meeting {
        pk
        id
      }
      report {
        reportType {
          labelDisplay
          id
        }
        project {
          name
          id
        }
        pk
        taskIdManager
        numberOfMinutesManager
        noteManager
        id
      }
    }
  }
}
*/

const node /*: ConcreteRequest*/ = (function () {
  var v0 = {
      kind: "ScalarField",
      alias: null,
      name: "createdAt",
      args: null,
      storageKey: null,
    },
    v1 = {
      kind: "ScalarField",
      alias: null,
      name: "id",
      args: null,
      storageKey: null,
    },
    v2 = {
      kind: "ScalarField",
      alias: null,
      name: "pk",
      args: null,
      storageKey: null,
    },
    v3 = {
      kind: "ScalarField",
      alias: null,
      name: "firstName",
      args: null,
      storageKey: null,
    },
    v4 = {
      kind: "ScalarField",
      alias: null,
      name: "lastName",
      args: null,
      storageKey: null,
    },
    v5 = {
      kind: "LinkedField",
      alias: null,
      name: "user",
      storageKey: null,
      args: null,
      concreteType: "UserType",
      plural: false,
      selections: [v2, v1, v3, v4],
    },
    v6 = {
      kind: "ScalarField",
      alias: null,
      name: "seen",
      args: null,
      storageKey: null,
    },
    v7 = {
      kind: "ScalarField",
      alias: null,
      name: "hidden",
      args: null,
      storageKey: null,
    },
    v8 = {
      kind: "ScalarField",
      alias: null,
      name: "management",
      args: null,
      storageKey: null,
    },
    v9 = {
      kind: "ScalarField",
      alias: null,
      name: "absenceStatus",
      args: null,
      storageKey: null,
    },
    v10 = {
      kind: "ScalarField",
      alias: null,
      name: "status",
      args: null,
      storageKey: null,
    },
    v11 = {
      kind: "ScalarField",
      alias: null,
      name: "absenceType",
      args: null,
      storageKey: null,
    },
    v12 = {
      kind: "ScalarField",
      alias: null,
      name: "absenceTypeDisplay",
      args: null,
      storageKey: null,
    },
    v13 = {
      kind: "ScalarField",
      alias: null,
      name: "dateFrom",
      args: null,
      storageKey: null,
    },
    v14 = {
      kind: "ScalarField",
      alias: null,
      name: "dateTo",
      args: null,
      storageKey: null,
    },
    v15 = {
      kind: "ScalarField",
      alias: null,
      name: "activity",
      args: null,
      storageKey: null,
    },
    v16 = {
      kind: "ScalarField",
      alias: null,
      name: "declaredTime",
      args: null,
      storageKey: null,
    },
    v17 = {
      kind: "ScalarField",
      alias: null,
      name: "labelDisplay",
      args: null,
      storageKey: null,
    },
    v18 = {
      kind: "ScalarField",
      alias: null,
      name: "name",
      args: null,
      storageKey: null,
    },
    v19 = {
      kind: "ScalarField",
      alias: null,
      name: "taskIdManager",
      args: null,
      storageKey: null,
    },
    v20 = {
      kind: "ScalarField",
      alias: null,
      name: "numberOfMinutesManager",
      args: null,
      storageKey: null,
    },
    v21 = {
      kind: "ScalarField",
      alias: null,
      name: "noteManager",
      args: null,
      storageKey: null,
    };
  return {
    kind: "Request",
    operationKind: "subscription",
    name: "NotificationSubscription",
    id: null,
    text:
      "subscription NotificationSubscription {\n  notificationSubscription {\n    notification {\n      id\n      pk\n      user {\n        pk\n        id\n        firstName\n        lastName\n      }\n      seen\n      hidden\n      management\n      absenceStatus\n      createdAt\n      absence {\n        status\n        absenceType\n        absenceTypeDisplay\n        dateFrom\n        dateTo\n        id\n      }\n      regardingUser {\n        firstName\n        lastName\n        id\n      }\n      employeeActivity {\n        activity\n        id\n      }\n      lateness {\n        declaredTime\n        pk\n        createdAt\n        id\n      }\n      meeting {\n        pk\n        id\n      }\n      report {\n        reportType {\n          labelDisplay\n          id\n        }\n        project {\n          name\n          id\n        }\n        pk\n        taskIdManager\n        numberOfMinutesManager\n        noteManager\n        id\n      }\n    }\n  }\n}\n",
    metadata: {},
    fragment: {
      kind: "Fragment",
      name: "NotificationSubscription",
      type: "Subscription",
      metadata: null,
      argumentDefinitions: [],
      selections: [
        {
          kind: "LinkedField",
          alias: null,
          name: "notificationSubscription",
          storageKey: null,
          args: null,
          concreteType: "NotificationSubscription",
          plural: false,
          selections: [
            {
              kind: "LinkedField",
              alias: null,
              name: "notification",
              storageKey: null,
              args: null,
              concreteType: "NotificationType",
              plural: false,
              selections: [
                v0,
                v1,
                v5,
                v6,
                v7,
                v8,
                v9,
                v2,
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "absence",
                  storageKey: null,
                  args: null,
                  concreteType: "AbsenceType",
                  plural: false,
                  selections: [v10, v11, v12, v13, v14],
                },
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "regardingUser",
                  storageKey: null,
                  args: null,
                  concreteType: "UserType",
                  plural: false,
                  selections: [v3, v4],
                },
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "employeeActivity",
                  storageKey: null,
                  args: null,
                  concreteType: "EmployeeActivityType",
                  plural: false,
                  selections: [v15],
                },
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "lateness",
                  storageKey: null,
                  args: null,
                  concreteType: "LatenessType",
                  plural: false,
                  selections: [v16, v2, v0],
                },
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "meeting",
                  storageKey: null,
                  args: null,
                  concreteType: "MeetingType",
                  plural: false,
                  selections: [v2],
                },
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "report",
                  storageKey: null,
                  args: null,
                  concreteType: "ReportType",
                  plural: false,
                  selections: [
                    {
                      kind: "LinkedField",
                      alias: null,
                      name: "reportType",
                      storageKey: null,
                      args: null,
                      concreteType: "RoleType",
                      plural: false,
                      selections: [v17],
                    },
                    {
                      kind: "LinkedField",
                      alias: null,
                      name: "project",
                      storageKey: null,
                      args: null,
                      concreteType: "ProjectType",
                      plural: false,
                      selections: [v18],
                    },
                    v2,
                    v19,
                    v20,
                    v21,
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    operation: {
      kind: "Operation",
      name: "NotificationSubscription",
      argumentDefinitions: [],
      selections: [
        {
          kind: "LinkedField",
          alias: null,
          name: "notificationSubscription",
          storageKey: null,
          args: null,
          concreteType: "NotificationSubscription",
          plural: false,
          selections: [
            {
              kind: "LinkedField",
              alias: null,
              name: "notification",
              storageKey: null,
              args: null,
              concreteType: "NotificationType",
              plural: false,
              selections: [
                v0,
                v1,
                v5,
                v6,
                v7,
                v8,
                v9,
                v2,
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "absence",
                  storageKey: null,
                  args: null,
                  concreteType: "AbsenceType",
                  plural: false,
                  selections: [v10, v11, v12, v13, v14, v1],
                },
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "regardingUser",
                  storageKey: null,
                  args: null,
                  concreteType: "UserType",
                  plural: false,
                  selections: [v3, v4, v1],
                },
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "employeeActivity",
                  storageKey: null,
                  args: null,
                  concreteType: "EmployeeActivityType",
                  plural: false,
                  selections: [v15, v1],
                },
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "lateness",
                  storageKey: null,
                  args: null,
                  concreteType: "LatenessType",
                  plural: false,
                  selections: [v16, v2, v0, v1],
                },
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "meeting",
                  storageKey: null,
                  args: null,
                  concreteType: "MeetingType",
                  plural: false,
                  selections: [v2, v1],
                },
                {
                  kind: "LinkedField",
                  alias: null,
                  name: "report",
                  storageKey: null,
                  args: null,
                  concreteType: "ReportType",
                  plural: false,
                  selections: [
                    {
                      kind: "LinkedField",
                      alias: null,
                      name: "reportType",
                      storageKey: null,
                      args: null,
                      concreteType: "RoleType",
                      plural: false,
                      selections: [v17, v1],
                    },
                    {
                      kind: "LinkedField",
                      alias: null,
                      name: "project",
                      storageKey: null,
                      args: null,
                      concreteType: "ProjectType",
                      plural: false,
                      selections: [v18, v1],
                    },
                    v2,
                    v19,
                    v20,
                    v21,
                    v1,
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  };
})();
// prettier-ignore
(node/*: any*/).hash = '8f391ba9068c50b1ae54b59af6d67e3d';
module.exports = node;



// WEBPACK FOOTER //
// ./src/subscriptions/__generated__/NotificationSubscription.graphql.js